export default {"src":"/_next/static/media/returns.31747c0e.svg","height":25,"width":25};